<template>
	<section>
		<div class="grid grid-cols-1 gap-3">
			<ProfileInsight
				v-for="insight in insights"
				:key="insight.id"
				:heading="
					$t(
						`personality_results.key-insights.${insight.heading}.heading`
					)
				"
				:body="$t(insight.body.insightKeys[0])"
			>
				<Component
					v-if="insight.icon"
					:is="insight.icon"
					size="20"
					class="shrink-0"
				/>
			</ProfileInsight>
		</div>
	</section>
</template>

<script>
import personalityResults from '~/mixins/personalityResults'
import ProfileInsight from './ProfileInsight'
import {
	IconTarget,
	IconDialogue,
	IconHandshake,
	IconLightbulb,
	IconShuffle,
	IconSuitcase
} from '~/components/Icons'

export default {
	name: 'OverviewProfileInsights',
	components: {
		ProfileInsight,
		IconTarget,
		IconDialogue,
		IconHandshake,
		IconLightbulb,
		IconShuffle,
		IconSuitcase
	},
	mixins: [personalityResults],
	props: {
		jobOfferData: {
			type: Object,
			default: () => {}
		},
		applicantData: {
			type: Object,
			default: () => {}
		},
		wheelMode: {
			type: String,
			required: true
		}
	},
	computed: {
		insights() {
			const insights = this.userIsApplicant
				? this.applicantInsights
				: this.hiringManagerInsights

			return [
				{
					id: 1,
					icon: IconTarget,
					heading: 'decision-making',
					body: insights.decisionMaking
				},
				{
					id: 2,
					icon: IconDialogue,
					heading: 'communication-style',
					body: insights.communicationStyle
				},
				{
					id: 3,
					icon: IconHandshake,
					heading: 'collaboration-style',
					body: insights.collaborationStyle
				},
				{
					id: 4,
					icon: IconLightbulb,
					heading: 'conflict-management',
					body: insights.conflictResolution
				},
				{
					id: 5,
					icon: IconShuffle,
					heading: 'adaptability',
					body: insights.adaptabilityToChange
				},
				{
					id: 6,
					icon: IconSuitcase,
					heading: 'work-environment',
					body: insights.workEnvironment
				}
			]
		}
	}
}
</script>
